export default __webpack_public_path__ + "static/media/arrow_up_down.e07c3b4b.svg";